var membership_styles = {
  membership_list: {
    display: "flex",
    flexDirection: "column" as const,
    gap: "16px",
    alignSelf: "stretch",
    width: "100%",
  },
  headline: {
    alignSelf: "stretch",
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    opacity: 0.5,
  },
  cards: {
    height: "inherit",
    width: "inherit",
    display: "inherit",
    flexDirection: "inherit" as const,
    gap: "inherit",
  },
  loader: {
    display: "flex",
    justifyContent: "center", // horizontal center
    alignItems: "center", //vertical center
    position: "inherit" as const,
    width: "100%",
  },
};

export default membership_styles;